import Vue from 'vue'
import MintUI from 'mint-ui'
import './lib/style.css'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './language/index';
import './utils/axios'
import './filters'
import '../public/font/iconfont.css'
import '../public/font/iconfont.js'
import VueTheMask from 'vue-the-mask'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import AccountKit from 'vue-facebook-account-kit'
import branch from '../node_modules/branch-sdk'

Vue.use(VueTheMask)
Vue.use(MintUI)
Vue.use(VueFacebookPixel)
Vue.use(AccountKit)
Vue.use(branch)

Vue.config.productionTip = false

window.Vue = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
